import React, {useEffect} from 'react';
import "./CheckList.scss";
import Button from "../../../partials/Button";
import Scroll from '../../../partials/Scroll/Scroll';
import BubbleTracker from '../../../partials/BubbleTracker/BubbleTracker';

function CheckList({ sensor, checklistsummarytitle, onRestart = () => {}, onComplete = () => {}, completeSegmentCaption = 'Complete Segment', retryButtonText = 'Retry' }) {
    const [isCheckListComplete, setIsCheckListComplete ] = React.useState(false)
    const [currentFeedback, setCurrentFeedback] = React.useState()
    const [Correct, setCorrect] = React.useState(false)
    const [showButttonAndFeedback, setShowButttonAndFeedback] = React.useState(false)
    const [currentQuestionIndex, setCurrentQuestionIndex] = React.useState(-1)
    const [currentQuestion, setCurrentQuestion] = React.useState()
    const [currentOptionIndex, setCurrentOptionIndex] = React.useState(null)
    const [ questions, setQuestions ] = React.useState( () => {
        const initValue = sensor.questions.map( q => {
            const questionOptions = q.options.map( o => ({
                ...o,
                id: createUUID(),
                isSelected: false,
            }))
            console.log(q.options, questionOptions)
            return {
                ...{
                    ...q,
                    id: createUUID(),
                },
                options:  questionOptions,
            }
        })
        return initValue
    })

    useEffect( () => {
        if (questions && questions.length >0) {
            setCurrentQuestionIndex(0)
        }
    }, [])

    useEffect(() => {
        setCurrentQuestion(questions[currentQuestionIndex])
    }, [currentQuestionIndex, questions ])
    if (!sensor ) {
        return null;
    }
    const handleOptionSelection = (q, o) => {
        setShowButttonAndFeedback(true)
        setCurrentFeedback(o.feedback)
        setCorrect(o.is_correct)
        const qSelected = {...q}
        qSelected.options = q.options.map( qo =>  {
            if (qo.id  === o.id) {
                return {
                    ...qo,
                    isSelected: true,
                }
            }
            return {
                ...qo,
                isSelected: false,
            }
        })
        const updatedQuestions = questions.map(qo => qo.id === qSelected.id ? qSelected : qo)
        setQuestions(updatedQuestions)
    }
    const handleRetry = () => {
        setShowButttonAndFeedback(false)
        const qSelected = {...currentQuestion}
        qSelected.options = currentQuestion.options.map( qo =>  {
            if (qo.id  === currentOptionIndex) {
                return {
                    ...qo,
                    isSelected: false,
                }
            }
            return {
                ...qo,
                isSelected: false,
            }
        })
        const updatedQuestions = questions.map(qo => qo.id === qSelected.id ? qSelected : qo)
        setQuestions(updatedQuestions)
    }
    return <div className="checklist">
    <div className={"checklist-container"}>
        <div className={"checklist-leftcontent"} >
            {currentQuestion && <div className={"checklist-question-container"}>
                {/* <div key={currentQuestion.category} className={"checklist-question-category"}>
                    {currentQuestion.category}
                </div> */}
                <div className={"checklist-question-title"}>
                    <div className={"checklist-question"}>
                    {currentQuestion.question}
                    </div>
                </div>
                <div className={"checklist-question-options"}>
                    <Scroll>
                        {currentQuestion.options.map(o => <div key={o.id}
                                                            className={o.isSelected === false?"checklist-question-option button expand":"checklist-question-option button expand selected"}
                                                            onClick={() => {if (showButttonAndFeedback==false){
                                                                handleOptionSelection(currentQuestion, o)
                                                                setCurrentOptionIndex(o.id)
                                                                }
                                                            }
                                                            }>
                            {o.caption}
                        </div>)}
                    </Scroll>
                </div>
            </div>}
            {currentFeedback && showButttonAndFeedback && currentQuestion.options.find(o => o.isSelected === true) && <div className={`checklist-questions-feedback ${currentQuestion.options.find(o => o.isSelected === true && o.is_correct===true)? "correct":"wrong"}`}>
               {currentQuestion.options.find(o => o.isSelected === true && o.is_correct===true)? <div className={"correct-answer-header"}>Awesome</div>:<div className={"wrong-answer-header"}>That's Not Right</div>}
               <Scroll>
             <div style={{minHeight:"50px", maxHeight:"322px",  padding:"10px 20px", overflow:"inherit"}}>{currentFeedback}</div>
             </Scroll>
             <div style={{textAlign:"center", padding:"5px 20px 0px 20px"}}>{Correct? 
            //    Commented as Discussed with Nickie - May be used in Next Phase of Development
            //     <Button text="Next" onClick={() => {
            //         if (currentQuestionIndex < questions.length - 1) {
            //             setCurrentQuestionIndex(currentQuestionIndex + 1)
            //             setShowButttonAndFeedback(false)
            //             return
            //         }
            //         if(currentQuestionIndex == questions.length-1){
            //             setIsCheckListComplete(true)
            //             return
            //         }
            //         setCurrentQuestionIndex(0)
            //     }}/>
             <Button text="Next" onClick={() => {
                if (currentQuestionIndex < questions.length - 1) {
                    setCurrentQuestionIndex(currentQuestionIndex + 1)
                    setShowButttonAndFeedback(false)
                    if(currentQuestionIndex == questions.length-2){
                        setIsCheckListComplete(true)
                        return
                    }
                    return
                } 
                if(currentQuestionIndex == questions.length - 1 && onComplete){
                    onComplete()
                }
                if(isCheckListComplete && onComplete){
                    onComplete()
                    return
                }
                setCurrentQuestionIndex(0)
            }}/>
            :
            <>
                <Button text={retryButtonText} onClick={()=>handleRetry() }/>
                <Button text={"Close"} onClick={() => {
                if (currentQuestionIndex < questions.length - 1) {
                    setCurrentQuestionIndex(currentQuestionIndex + 1)
                    setShowButttonAndFeedback(false)
                    if(currentQuestionIndex == questions.length-2){
                        setIsCheckListComplete(true)
                        return
                    }
                    return
                } 
                if(currentQuestionIndex == questions.length - 1 && onComplete){
                    onComplete()
                }
                if(isCheckListComplete && onComplete){
                    onComplete()
                    return
                }
                setCurrentQuestionIndex(0)
            }}/>
            </>
            }
            </div>
            </div>}



        </div>
        <div className={"checklist-rightcontent"}>
            <div style={{display:"flex",height: "120px", width:"100%", padding: "20px"}}>
        <div className={"checklist-sensor-img"} >
                <img src={sensor.img} alt={sensor.type} />

            </div>
            <div className={"checklist-sensor-caption"} >
                {sensor && sensor.type}
            </div>
            </div>
            <div className={"checklist-summary"} >
                <h1>{checklistsummarytitle}</h1>
                <Scroll>
                {/* Commented as Discussed with Nickie - May be used in Next Phase of Development
                <div style={{height:"150px"}}> */}
                <div style={{height:"275px"}}>
                {
                    questions && questions.map((q,i) => {
                        return <div style={{display:"flex"}}>
                        <div key={q.category} className={"checklist-summary-item"}>
                            <div className={"checklist-summary-item-title"}>
                                {q.category}:
                            </div>
                            <div className={"checklist-summary-item-value"}>
                                {q.options.find( o => o.isSelected === true)?.caption  || 'TBD'}
                            </div>
                        </div>
                         <div className={`checklist-summary-item-checkicon ${q.options.find( o => o.isSelected === true) ? '' : 'hidden'}`}  >
                             <div>
                             {q.options.find( o => o.isSelected === true&&o.is_correct===true)?<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><g id="icn-Correct" transform="translate(-119 -317)"><g id="Ellipse_242" data-name="Ellipse 242" transform="translate(119 317)" fill="#63c132" stroke="#eee5e9" stroke-width="2"><circle cx="15" cy="15" r="15" stroke="none"></circle><circle cx="15" cy="15" r="14" fill="none"></circle></g><path id="Icon_awesome-check" data-name="Icon awesome-check" d="M7.083,19.823.305,13.045a1.043,1.043,0,0,1,0-1.475L1.78,10.1a1.043,1.043,0,0,1,1.475,0L7.82,14.662,17.6,4.883a1.043,1.043,0,0,1,1.475,0l1.475,1.475a1.043,1.043,0,0,1,0,1.475L8.558,19.823A1.043,1.043,0,0,1,7.083,19.823Z" transform="translate(123.573 320.647)" fill="#eee5e9"></path></g></svg>:<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><g id="icn-Incorrect" transform="translate(-119 -317)"><g id="Ellipse_242" data-name="Ellipse 242" transform="translate(119 317)" fill="#a31621" stroke="#eee5e9" stroke-width="2"><circle cx="15" cy="15" r="15" stroke="none"></circle><circle cx="15" cy="15" r="14" fill="none"></circle></g><path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M21.744,19.742l6.04-6.04a1.415,1.415,0,0,0-2-2l-6.04,6.04L13.7,11.7a1.415,1.415,0,1,0-2,2l6.04,6.04-6.04,6.04a1.415,1.415,0,0,0,2,2l6.04-6.04,6.04,6.04a1.415,1.415,0,0,0,2-2Z" transform="translate(114.259 312.258)" fill="#eee5e9"></path></g></svg>}
                         </div>
                      </div>
                      </div>

                    })
                }
                </div>
                </Scroll>
            </div>
            {/* Commented as Discussed with Nickie - May be used in Next Phase of Development
            {isCheckListComplete && <div className={"checklist-finalbuttons"}>
                    <Button text="Next" onClick={() => {
                                    if (onComplete) {
                                        onComplete()
                                       }
                            } }/>
            </div>} */}
        </div>
    </div>
    <div style={{textAlign:"center"}}>
        <BubbleTracker total={questions.length} current={currentQuestionIndex} />
    </div>
    </div>
}
function createUUID(){
    return '_' + Math.random().toString(36).substr(2, 9);
}
export default CheckList;
